import React from "react";

import GnbMenuWrapper from "../util/GnbMenuWrapper";

import HomeItem from "./content/HomeItem";
import Item from "./content/Item";

function HomeMenu(props) {
    const { menuInfo, changeFirstDepthMenu } = props;
    return (
        <GnbMenuWrapper>
            {menuInfo.map((info, idx) => {
                if (info.MENU_CD !== "TDAY") {
                    return (
                        <Item key={idx} text={info.MENU_NAME} info={info} changeFirstDepthMenu={changeFirstDepthMenu} />
                    );
                }
                return <HomeItem key={idx} text={info.MENU_NAME} />;
            })}
        </GnbMenuWrapper>
    );
}

export default HomeMenu;
